export default "__VITE_ASSET__URGLoJmBgD1E8hzYMpiEiA__"